import { createSlice } from '@reduxjs/toolkit';
import { updatePatientNameApi } from '../../../rtk-apis/reports/updatePatientName';

const initialState = { status: '', msg: '', loading: false };

const updatePatientNameSlice = createSlice({
  name: 'updatePatientName',
  initialState,
  reducers: {
    clearState: state => { state.status = ''; state.msg = ''; state.loading = false; },
  },
  extraReducers: builder => {
    builder
      .addCase(updatePatientNameApi.pending, state => { state.loading = true; })
      .addCase(updatePatientNameApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.msg = action?.payload?.msg || '';
      })
      .addCase(updatePatientNameApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
      });
  },
});

export const { clearState } = updatePatientNameSlice.actions;
export default updatePatientNameSlice.reducer;
